import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, Row, Col, Form, Input } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getConfig, updateConfig } from './appConfig.reducer';

export const AppConfigUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const config = useAppSelector(state => state.appConfig.entity);

  useEffect(() => {
    dispatch(getConfig(props.match.params.id));
  }, [form]);

  useEffect(() => {
    if (config && config.id) {
      form.setFieldsValue(config);
    }
  }, [config, form]);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/configuration`);
  };
  const goBack = () => {
    props.history.goBack();
  };
  const saveEntity = values => {
    const entity = {
      ...config,
      ...values,
    };
    dispatch(updateConfig(entity));
    handleClose(event);
  };
  return (
    <>
      {config.id !== null && (
        <Modal
          title="Edit App-Configuration"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          <Row className="justify-content-center">
            <Col span={18} offset={4}>
              <Form
                form={form}
                labelCol={{ span: 4 }}
                onFinish={saveEntity}
                wrapperCol={{ span: 14 }}
                layout="vertical"
                size="large"
                initialValues={config}
              >
                <Form.Item label="Clé" name="configKey">
                  <Input placeholder="key" />
                </Form.Item>
                <Form.Item label="Valeur" name="value">
                  <Input placeholder="value" />
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{ backgroundColor: '#F28E19', color: 'white' }}
                    data-cy="entityCreateSaveButton"
                    htmlType="submit"
                    id="save-entity"
                  >
                    <FontAwesomeIcon icon="save" />
                    &nbsp; Enregistrer
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

export default AppConfigUpdate;
